module.exports = __webpack_public_path__ + "static/5import-21540b4ea693dd40830ce0c49b18db56.png";